import { Component, OnDestroy, OnInit } from '@angular/core';
import { of, Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AppService } from '../../../services/app.service';
import { ITableColumn } from '../../../shared/table/table.component';
import { IPlanSummaryUpcomingCourse } from '../../../models/PlanSummary';
import { Util } from '../util';
import { PlanSummaryService } from '../../../services/plan-summary.service';
import { ICurrentRequest, getCurrentRequest } from '../plan-summary.component';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-plan-summary-upcoming-courses',
    templateUrl: './plan-summary-upcoming-courses.component.html',
    styleUrls: ['../plan-summary.component.scss']
})
export class PlanSummaryUpcomingCoursesComponent implements OnInit, OnDestroy {
    constructor(
        private app: AppService,
        private service: PlanSummaryService
    ) {
    }

    rows: IPlanSummaryUpcomingCourse[] = [];
    isLoaded: boolean;

    readonly util = Util;
    readonly weeksPostfix: string;

    readonly columns: ITableColumn[] = [
        { property: 'StudyYear', label: 'planSummary_plan_lblStudyYear', sorts: true, type: 'number' },
        { property: 'Name', label: 'planSummary_plan_lblCourse', sorts: true },
        { property: 'Ects', label: 'planSummary_plan_lblEcts', cssClass: 'hidden-md-down', sorts: true, type: 'number' },
        { property: 'WeekCount', label: 'planSummary_plan_lblWeekCount', cssClass: 'hidden-md-down', sorts: true, type: 'number' }
    ];

    private request: ICurrentRequest;
    private requestSub: Subscription;

    ngOnInit() {
        this.requestSub = getCurrentRequest().subscribe(req => {
            this.request = req;
            this.load();
        });
    }

    ngOnDestroy() {
        this.requestSub?.unsubscribe();
    }

    private load(force: boolean = false) {
        if (force) {
            this.request.store.courses = undefined;
        }

        this.getData().subscribe(data => {
            this.rows = data;
            this.isLoaded = true;
        }, err => {
            console.log(err);
        });
    }

    private getData(): Observable<IPlanSummaryUpcomingCourse[]> {
        if (this.request.store.courses) {
            return of(this.request.store.courses);
        } else {
            return this.app.addLoading(this.service.getUpcomingCourses(this.request.params)).pipe(tap((data: IPlanSummaryUpcomingCourse[]) => {
                this.request.store.courses = data;
            }));
        }
    }
}
